import allEmojiData from 'emoji-mart/data/all.json';

import { escapeRegExp } from '../md-utils';

const createRule = (md, emojisMap, scanRE, replaceRE) => {
    const arrayReplaceAt = md.utils.arrayReplaceAt;
    const ucm = md.utils.lib.ucmicro;
    const ZPCc = new RegExp([ ucm.Z.source, ucm.P.source, ucm.Cc.source ].join('|'));

    const splitTextToken = (text, level, Token) => {
        const nodes = [];
        let lastPos = 0;
        let token;

        text.replace(replaceRE, (match, emojiId, emojiSkin, offset, src) => {
            const emoji = emojisMap.emojis[emojiId];

            if (emoji) {
                // Don't allow letters before any shortcut (as in no ":/" in http://)
                if (offset > 0 && !ZPCc.test(src[offset - 1])) {
                    return;
                }
            } else {
                emojiId = match.slice(1, -1);
            }

            // Add new tokens to pending list
            if (offset > lastPos) {
                token = new Token('text', '', 0);
                token.content = text.slice(lastPos, offset);
                nodes.push(token);
            }

            token = new Token('emoji', '', 0);
            token.attrs = [
                ['id', emojiId],
                ['skin', (emojiSkin || '0') - 0],
                ['emojionly', text.length === match.length]
            ];

            token.content = ''; // set content
            nodes.push(token);

            lastPos = offset + match.length;

        });

        if (lastPos < text.length) {
            token = new Token('text', '', 0);
            token.content = text.slice(lastPos);
            nodes.push(token);
        }

        return nodes;
    }

    return state => {
        var i, j, l, tokens, token,
                blockTokens = state.tokens,
                autolinkLevel = 0;

        for (j = 0, l = blockTokens.length; j < l; j++) {
            if (blockTokens[j].type !== 'inline') { continue; }
            tokens = blockTokens[j].children;

            // We scan from the end, to keep position when new tags added.
            // Use reversed logic in links start/end match
            for (i = tokens.length - 1; i >= 0; i--) {
                token = tokens[i];

                if (token.type === 'link_open' || token.type === 'link_close') {
                    if (token.info === 'auto') { autolinkLevel -= token.nesting; }
                }

                if (token.type === 'text' && autolinkLevel === 0 && scanRE.test(token.content)) {
                    // replace current node
                    blockTokens[j].children = tokens = arrayReplaceAt(
                        tokens, i, splitTextToken(token.content, token.level, state.Token)
                    );
                }
            }
        }
    };
};

const emojis = Object.keys(allEmojiData.emojis).map(emoji => escapeRegExp(emoji)).join('|');
export const emojisRegex = `:(${emojis}):(?::skin-tone-(\\d):)?`;

const emoticons = Object.values(allEmojiData.emojis).map(e => e.emoticons || e.l).flat().filter(Boolean).map(emoticon => escapeRegExp(emoticon)).join('|');
export const emoticonsRegex = `(${emoticons})`;

export const getColonsByEmoticon = emoticon => Object.keys(allEmojiData.emojis).find(colons => allEmojiData.emojis[colons].emoticons.includes(emoticon));

export default function plugin(md, options) {
    md.core.ruler.push('emoji', createRule(md, allEmojiData, RegExp(emojisRegex), RegExp(emojisRegex, 'g')));
};
